import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navigation/Navbar";
import Main from "./components/main/Main";
import Gallery from "./components/gallery/Gallery";
import Archives from "./components/archives/Archives";
import { ThemeProvider, styled } from "@mui/material";
import { theme } from "./Theme";
import About from "./components/about/About";

const AppShell = styled("div")(({ theme }) => ({
  minHeight: "100vh",
  background:
    "radial-gradient(circle at top, rgba(255, 255, 255, 0.45), transparent 28%)",
}));

const ContentShell = styled("main")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  padding: "1.5rem 1.5rem 3rem",
  color: theme.palette.text.primary,
  [theme.breakpoints.down("sm")]: {
    padding: "1rem 0.75rem 2rem",
  },
}));

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AppShell>
          <Navbar />
          <ContentShell>
            <Routes>
              <Route exact path="/" element={<Main />}></Route>
              <Route exact path="/about" element={<About />}></Route>
              <Route exact path="/archives" element={<Archives />}></Route>
              <Route exact path="/gallery" element={<Gallery />}></Route>
            </Routes>
          </ContentShell>
        </AppShell>
      </Router>
    </ThemeProvider>
  );
}

export default App;
